import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgZoeken = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="m34 31.085-6.941-6.93a10.98 10.98 0 1 0-2.903 2.904L31.085 34zm-21.846-7.283a8.242 8.242 0 1 1 11.648 0 8.254 8.254 0 0 1-11.648 0"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M12.5 17a6.48 6.48 0 0 0 1.9 4.595A6.5 6.5 0 0 0 19 23.5v1a7.5 7.5 0 0 1-5.308-2.198A7.48 7.48 0 0 1 11.5 17z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgZoeken);

export default ForwardRef;
